import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Assalamualikum Everyone, I am <span className="purple">Dewan Nishat Ahmed</span><br/>
            from <span className="purple"> Dhaka, Bangladesh.</span>
            I am a Web Developer,and I am very passionate and dedicated to my work
            with 1 years experience as a professional Web Developer,
            I have acquired the skills and knowledge necessary to make your project a success
            <br/>
            <br />I am an Honors 3rd year Physics student and Programming Hero Batch: 3 student.
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Playing Games
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Volunteering
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Travelling
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Someone should benefit if I can, but I shouldn’t be harmed if I can’t !"{" "}
          </p>
          <footer className="blockquote-footer">Nishat Ahmed</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
